import React, { Component } from 'react';
import GBIVennConceptMobile from './GBIVennConceptMobile';
import GBIVennConceptDesktop from './GBIVennConceptDesktop';
import PropTypes from 'prop-types';

class GBIVennConcept extends Component {
  constructor (props) {
    super(props);
    this.state = {
      device: window.innerWidth < 900 ? 'mobile' : 'desktop'
    };
    this.handleResize = this.handleResize.bind(this);
  }
  componentDidMount () {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize () {
    const device = window.innerWidth < 900 ? 'mobile' : 'desktop';
    if (device !== this.state.device) {
      this.setState({ device });
    }
  }
  render () {
    return this.state.device === 'mobile' ?
      <GBIVennConceptMobile
        score={ this.props.score }
        view={this.props.view} /> :
      <GBIVennConceptDesktop
        score={ this.props.score }
        view={this.props.view} />;
  }
}

GBIVennConcept.propTypes = {
  score: PropTypes.number,
  view: PropTypes.oneOf(['core', 'concept'])
};

export default GBIVennConcept;
